module.exports = __webpack_public_path__ + "static/media/sidebar-2.2c6db2e7.jpg";